// extracted by mini-css-extract-plugin
export default {"container":"MainContent-module__container--ry4iL","inner":"MainContent-module__inner--bU_tk","compact":"MainContent-module__compact--mM626"};